module.exports = __webpack_public_path__ + "static/media/funds.fa4ec10f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tradingPreferences/funds.svg
// module id = 348
// module chunks = 21